<script>
    import { stylesColors } from '../helpers/style.helper';

    export let value = null, inverted = false;
    let val = value;
    let defaultValue = {
        emptyColor: 'default',
        minColor: 'red',
        midColor: 'yellow',
        maxColor: 'green',
        minValue: 50,
        maxValue: 80,
    };

    if(inverted){
        defaultValue.minColor = 'green';
        defaultValue.maxColor = 'red';
    }

    try {
        val = val ? JSON.parse(value) : defaultValue;
    } catch(e) {
        val = defaultValue;
    }

    function onChange() {
        value = JSON.stringify(val);
    }

    $: val, onChange();

</script>
<div class="form-group row">
    <div class="col-4 pt-4 text-muted">
        <label>Empty cell:</label>
    </div>
    <div class="col-4">
        <div class="dropdown color-scheme-picker">
            Color:
            <button class="form-control btn-default btn-block dropdown-toggle text-capitalize style-{val.emptyColor}"
                    type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                { val.emptyColor }
                <span class="caret"></span>
            </button>

            <ul class="dropdown-menu color-scheme-panel" aria-labelledby="dropdown-color-picker">
                <li class="dropdown-header text-uppercase">Choose a color</li>
                <li role="separator" class="divider"></li>
                {#each stylesColors as color}
                    <li class="p-2 text-capitalize style-{color}"
                        on:click={() => val.emptyColor = color}>
                        {color}
                    </li>
                {/each}
            </ul>
        </div>
    </div>
</div>

{#if inverted}
    <div class="form-group row">
        <div class="col-4 pt-4 text-muted">
            <label>Greater than:</label>
        </div>
        <div class="col-4">
            <div class="dropdown color-scheme-picker">
                Color:
                <button class="form-control btn-default btn-block dropdown-toggle text-capitalize style-{val.maxColor}"
                        type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    { val.maxColor }
                    <span class="caret"></span>
                </button>

                <ul class="dropdown-menu color-scheme-panel" aria-labelledby="dropdown-color-picker">
                    <li class="dropdown-header text-uppercase">Choose a color</li>
                    <li role="separator" class="divider"></li>
                    {#each stylesColors as color}
                        <li class="p-2 text-capitalize style-{color}"
                            on:click={() => val.maxColor = color}>
                            {color}
                        </li>
                    {/each}
                </ul>
            </div>
        </div>
        <div class="col-3">
            Value:
            <input class="form-control" type="number" bind:value={val.maxValue} on:click={onChange}>
        </div>
    </div>
{:else}
    <div class="form-group row">
        <div class="col-4 pt-4 text-muted">
            <label>Lower than:</label>
        </div>
        <div class="col-4">
            <div class="dropdown color-scheme-picker">
                Color:
                <button class="form-control btn-default btn-block dropdown-toggle text-capitalize style-{val.minColor}"
                        type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    { val.minColor }
                    <span class="caret"></span>
                </button>

                <ul class="dropdown-menu color-scheme-panel" aria-labelledby="dropdown-color-picker">
                    <li class="dropdown-header text-uppercase">Choose a color</li>
                    <li role="separator" class="divider"></li>
                    {#each stylesColors as color}
                        <li class="p-2 text-capitalize style-{color} "
                            on:click={() => val.minColor = color}>
                            {color}
                        </li>
                    {/each}
                </ul>
            </div>
        </div>
        <div class="col-3">
            Value:
            <input class="form-control" type="number" bind:value={val.minValue} on:click={onChange}>
        </div>
    </div>
{/if}

<div class="form-group row">
    <div class="col-4 pt-4 text-muted">
        <label>Between:</label>
    </div>
    <div class="col-4">
        <div class="dropdown color-scheme-picker">
            Color:
            <button class="form-control btn-default btn-block dropdown-toggle text-capitalize style-{val.midColor}"
                    type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                { val.midColor }
                <span class="caret"></span>
            </button>

            <ul class="dropdown-menu color-scheme-panel" aria-labelledby="dropdown-color-picker style-{val.midColor}">
                <li class="dropdown-header text-uppercase">Choose a color</li>
                <li role="separator" class="divider"></li>
                {#each stylesColors as color}
                    <li class="p-2 text-capitalize style-{color}"
                        on:click={() => val.midColor = color}>
                        {color}
                    </li>
                {/each}
            </ul>
        </div>
    </div>
</div>

{#if !inverted}
    <div class="form-group row">
        <div class="col-4 pt-4 text-muted">
            <label>Greater than:</label>
        </div>
        <div class="col-4">
            <div class="dropdown color-scheme-picker">
                Color:
                <button class="form-control btn-default btn-block dropdown-toggle text-capitalize style-{val.maxColor}"
                        type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    { val.maxColor }
                    <span class="caret"></span>
                </button>

                <ul class="dropdown-menu color-scheme-panel" aria-labelledby="dropdown-color-picker">
                    <li class="dropdown-header text-uppercase">Choose a color</li>
                    <li role="separator" class="divider"></li>
                    {#each stylesColors as color}
                        <li class="p-2 text-capitalize style-{color}"
                            on:click={() => val.maxColor = color}>
                            {color}
                        </li>
                    {/each}
                </ul>
            </div>
        </div>
        <div class="col-3">
            Value:
            <input class="form-control" type="number" bind:value={val.maxValue} on:click={onChange}>
        </div>
    </div>
{:else}
    <div class="form-group row">
        <div class="col-4 pt-4 text-muted">
            <label>Lower than:</label>
        </div>
        <div class="col-4">
            <div class="dropdown color-scheme-picker">
                Color:
                <button class="form-control btn-default btn-block dropdown-toggle text-capitalize style-{val.minColor}"
                        type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    { val.minColor }
                    <span class="caret"></span>
                </button>

                <ul class="dropdown-menu color-scheme-panel" aria-labelledby="dropdown-color-picker">
                    <li class="dropdown-header text-uppercase">Choose a color</li>
                    <li role="separator" class="divider"></li>
                    {#each stylesColors as color}
                        <li class="p-2 text-capitalize style-{color} "
                            on:click={() => val.minColor = color}>
                            {color}
                        </li>
                    {/each}
                </ul>
            </div>
        </div>
        <div class="col-3">
            Value:
            <input class="form-control" type="number" bind:value={val.minValue} on:click={onChange}>
        </div>
    </div>
{/if}